import classnames from '../../node_modules/classnames/index.js';
import { useState, createElement } from 'react';
import Button from './Button.js';
import imageError from '../images/icons/input-error.svg';
import imageHidePassword from '../images/icons/input-hide-password.svg';
import imageInfo from '../images/icons/input-info.svg';
import imageShowPassword from '../images/icons/input-show-password.svg';
import imageSearch from '../images/icons/search.svg';
import styles from '../styles/Input.module.scss';

var InputWrapper = function (_a) {
    var className = _a.className, children = _a.children, error = _a.error, helperText = _a.helperText, inputType = _a.inputType, hasFocusIndicator = _a.hasFocusIndicator;
    var _b = useState(false), isShowingPassword = _b[0], setIsShowingPassword = _b[1];
    var wrapSuffix = error
        ? "-invalid"
        : hasFocusIndicator
            ? "-focus-indicator"
            : "";
    return (createElement("div", { className: classnames(styles["wrap" + wrapSuffix], className) },
        inputType === "search" ? (createElement("img", { alt: "", className: styles.search, src: imageSearch })) : null,
        children({
            inputType: inputType === "date" || isShowingPassword ? "text" : inputType,
        }),
        inputType === "textarea" ? null : error ? (createElement("img", { className: styles.icon, src: imageError })) : helperText ? (createElement("img", { className: styles.icon, src: imageInfo })) : inputType === "password" ? (createElement(Button, { className: styles["eye-button"], onClick: function () { return setIsShowingPassword(function (value) { return !value; }); }, 
            // The default behavior is to submit when the input/button
            // is part of a <form>.
            type: "button" },
            createElement("img", { className: styles.eye, src: isShowingPassword ? imageHidePassword : imageShowPassword }))) : null));
};

export default InputWrapper;
